// extracted by mini-css-extract-plugin
export default {"container":"AppliedFilters_container__c7-Ku","flexMenu":"AppliedFilters_flexMenu__aD5j2","clearFilters":"AppliedFilters_clearFilters__DXxw8"};